import React, { useState, useEffect } from "react";

import { DataGrid } from "@material-ui/data-grid";
import { Container, Grid } from "@material-ui/core";

import { GridStyled, LabelStyled } from "../../styles/GlobalStyle";
import { formatDateBrazilian } from "../../utils/formatDate";
import MaskService from "../../utils/mask/maskService";
import { reportLiberations } from "../../repositories/v1/report";
import ExportExcel from "./ExportExcel";

const columns = [
  {
    field: "CNPJ",
    headerName: "CNPJ/CPF",
    width: 161,
    renderCell: ({ row }) =>
      MaskService.toMask(
        row?.empresa?.CNPJ.length > 11 ? "cnpj" : "cpf",
        row?.empresa?.CNPJ || ""
      ),
  },
  {
    field: "Razao",
    headerName: "Razão",
    minWidth: 250,
    flex: 1,
    renderCell: ({ row }) => row?.empresa?.Razao,
  },
  {
    field: "Data",
    headerName: "Data",
    width: 145,
    renderCell: ({ row }) => row?.mapa?.Data,
    align: "center",
  },
  {
    field: "FranqueadoCNPJ",
    headerName: "Franqueado CNPJ",
    width: 161,
    renderCell: ({ row }) =>
      MaskService.toMask(
        (row?.promocode?.IdPromotorFranquia || "").length > 11 ? "cnpj" : "cpf",
        row?.promocode?.IdPromotorFranquia || ""
      ),
    align: "center",
  },
  {
    field: "FranqueadoEmail",
    headerName: "Franqueado Email",
    minWidth: 170,
    flex: 1,
    renderCell: ({ row }) => row?.promocode?.usuario?.Email,
    align: "center",
  },
  {
    field: "Codigo",
    headerName: "Tipo Cartão",
    width: 125,
    renderCell: ({ row }) => row.fenaconCliente.TipoCartao,
    align: "center",
  },
];

function ReportLiberations() {
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const { data: respReport } = await reportLiberations();

        if (respReport?.success && Array.isArray(respReport.data)) {
          const newArr = respReport.data.map((i) => ({
            ...i,
            mapa: {
              ...i.mapa,
              Data: formatDateBrazilian(i.mapa.createdAt, true),
            },
            fenaconCliente: {
              ...i.fenaconCliente,
              TipoCartao: i?.fenaconCliente?.Codigo
                ? i.fenaconCliente.Codigo.includes("8932")
                  ? "Platinum"
                  : "Black"
                : "",
            },
          }));

          setAllRows(newArr);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Container maxWidth="lg">
      <GridStyled
        container
        padding="20px 0 20px 0"
        justify="space-between"
        spacing={1}
      >
        <Grid item>
          <LabelStyled fontSize="26">
            Relatório: Bases Liberadas para Escritórios
          </LabelStyled>
        </Grid>

        {!loading && (
          <Grid item>
            <ExportExcel valuesTable={allRows} />
          </Grid>
        )}

        <Grid item xs={12}>
          <DataGrid
            autoHeight
            disableColumnMenu
            loading={loading}
            rows={allRows}
            columns={columns}
            pageSize={10}
          />{" "}
        </Grid>
      </GridStyled>
    </Container>
  );
}

export { ReportLiberations };
